import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [result, setResult] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResult("Sending....");
    
    const formDataToSend = new FormData(e.target);
    formDataToSend.append("access_key", "de82d4e7-e13b-4dea-b55d-2645e6c88f04");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formDataToSend
      });

      const data = await response.json();
      
      if (data.success) {
        setResult("Message sent successfully!");
        setSubmitted(true);
        setTimeout(() => {
          setSubmitted(false);
          setResult("");
          setFormData({ name: '', email: '', subject: '', message: '' });
        }, 3000);
      } else {
        setResult("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error('Error:', error);
      setResult("An error occurred. Please try again later.");
    }
  };

  return (
    <div>
      <div className="header user-header">
        <div className="container">
          <h1>Contact Us</h1>
        </div>
      </div>

      <div className="container">
        <div className="content-page">
          <section>
            <h2>Get in Touch</h2>
            <p>
              Have a question, suggestion, or want to report an issue? We're here to help!
              Fill out the form below and we'll get back to you as soon as possible.
            </p>
          </section>

          <div className="contact-form">
            {submitted ? (
              <div className="success-message">
                <h3>✓ Thank You!</h3>
                <p>Your message has been received. We'll get back to you soon.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Your Name"
                  />
                </div>

                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label>Subject *</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="What is this about?"
                  />
                </div>

                <div className="form-group">
                  <label>Message *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Your message..."
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">Send Message</button>
                {result && <p style={{ marginTop: '15px', textAlign: 'center', color: result.includes('success') ? '#2d6a4f' : '#e74c3c', fontWeight: '600' }}>{result}</p>}
              </form>
            )}
          </div>

          <section style={{ marginTop: '40px' }}>
            <h2>Other Ways to Reach Us</h2>
            <div className="contact-info">
              <p><strong>Email:</strong> support@couponaadda.in</p>
              <p><strong>Response Time:</strong> Within 24-48 hours</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Contact;
